import { useMutation, useQueryClient } from "@tanstack/react-query"
import { deleteProductImage } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useDeleteProductImage(productId: string) {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (imageId: string) => {
      if (!token) throw new Error("No token available")
      return deleteProductImage(productId, imageId, token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product", productId] })
    },
  })
}
